import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/arrow_right.svg
 */
const IconArrowRight: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      opacity={0.9}
      d="M17.988 12.273c.02-.082.03-.165.035-.249a1.482 1.482 0 00-.035-.256 1.27 1.27 0 00-.062-.24 1.17 1.17 0 00-.14-.237.65.65 0 00-.085-.152L8.315.454a1.334 1.334 0 10-2.006 1.761l8.61 9.81-8.61 9.799a1.337 1.337 0 002.006 1.764L17.7 12.905a.678.678 0 00.085-.155c.056-.073.103-.15.14-.235.029-.078.05-.16.062-.242z"
      fill="currentColor"
    />
  </svg>
);

export default IconArrowRight;
